import { render, staticRenderFns } from "./RequestTypesList.vue?vue&type=template&id=71e2ef4a&scoped=true"
import script from "./RequestTypesList.vue?vue&type=script&lang=js"
export * from "./RequestTypesList.vue?vue&type=script&lang=js"
import style0 from "./RequestTypesList.vue?vue&type=style&index=0&id=71e2ef4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2ef4a",
  null
  
)

export default component.exports